var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDevelopment = function SvgDevelopment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    fillRule: "evenodd",
    d: "M7.164 3h-4v6.352h4V8.015h2.034V20H6.164v1h10v-1H13.17V8.015h4.017v3.009h-2.023V16h5v-4.976h-1.977v-3.01h2.977l-3.23-3.674H7.164zm0 2.34v1.675h11.79L17.48 5.34zm-3 3.012V4h2v4.352zm6.034-.337h1.972V20h-1.972zm5.966 4.009V15h3v-2.976z",
    clipRule: "evenodd"
  })));
};
export default SvgDevelopment;